export enum HeightmapModuleLayerType {
  heightmap = 'heightmap',
  twelvePercent = 'twelvePercent',
  seventeenPercent = 'seventeenPercent',
  contours = 'contours'
}

export enum HeightmapCoverageState {
  UNCOVERED = 'uncovered',
  PARTIALLY_COVERED = 'partiallyCovered',
  COVERED = 'covered'
}

export enum HeightmapLayerType {
  INCLINE_12_PCT = 'incline12Pct',
  INCLINE_17_PCT = 'incline17Pct',
  INCLINE_CONTOURS = 'inclineContours'
}
